import Cookie from 'cookie-universal'

import { ONE_DAY } from '@mc/constants'

const PROMO_MODAL_EMAIL_CAPTURE_COOKIE = 'promo_modal_email_capture_cookie'

export const setPromoModalEmailCaptureCookie = () => {
  const cookies = Cookie()

  cookies.set(PROMO_MODAL_EMAIL_CAPTURE_COOKIE, true, {
    maxAge: ONE_DAY,
  })
}
